import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import Button from '@/components/Button';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import fileTypes from "@/constants/file-type/index";
import rem from "@/utils/rem";
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';

const DownloadModal = ({downloadModal, hideDownloadModal, handleDownloadIdentity}) => {
	return (
		<Modal visible={downloadModal} variant='medium'  close={hideDownloadModal}>
			<CardConfigure >
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconConfigure />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Download My Wallet Address
									</div>
								</div>
							</div>
						</div>

					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div>Please select file format for downloading your wallet address</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button text="JSON"
							submit={() => {
								hideDownloadModal()
								handleDownloadIdentity(fileTypes.json)
							}}
						/>
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button text="CSV"
							submit={() => {
								hideDownloadModal()
								handleDownloadIdentity(fileTypes.csv)
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}

export default DownloadModal
